import { AbsDecoder } from '../../utils/AbsDecoder';
import jwtDecode from 'jwt-decode';
import { ITokenData } from './tokenProvider.interfaces';

export class TokenDecoder extends AbsDecoder<string, ITokenData | undefined> {
  constructor(token?: string) {
    const decodeFn = (tok: string): ITokenData | undefined => {
      try {
        return jwtDecode(tok) as ITokenData;
      }
      catch (err) {
        console.error(`Decoded token error: ${err}!`);
      }
      return undefined;
    }
    super(decodeFn, token || '');
    if (!token)
      console.error(`Provided token is empty!`);
  }

  /**
   * It gets decoded token
   * @returns ITokenData
   */
  public get token(): ITokenData | undefined {
    return this.DecodedData;
  }
}